<div class="container mt-4">
    <h1 class="page-title primary-gradiant mb-5">
        {{ "pages.users_management.title" | translate }}
    </h1>

    <div class="table-header">
        <mat-form-field class="search-input">
            <input matInput
                    [formControl]="searchControl"
                    [placeholder]="'pages.users_management.search_by' | translate"
            />
        </mat-form-field>
        <mat-form-field class="role-filter">
            <mat-select [formControl]="roleFilterControl" placeholder="{{ 'pages.users_management.filter_by_role' | translate }}">
                <mat-option [value]="">
                    {{ 'common.all' | translate }}
                </mat-option>
                <mat-option *ngFor="let role of ROLE_OPTIONS" [value]="role.value">
                    {{ role.label | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <div class="float-end">
            <button mat-raised-button color="primary" (click)="openUserDialog()">
                {{ "pages.users_management.actions.add_user" | translate }}
            </button>
        </div>
    </div>

    <div class="table-container">
        <table mat-table [dataSource]="dataSource" matSort class="mat-table">
            <!-- IGG Column -->
            <ng-container matColumnDef="igg">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="user.igg">
                    {{ "models.user.igg" | translate }}
                </th>
                <td mat-cell *matCellDef="let user">{{ user.igg }}</td>
            </ng-container>

            <!-- First Name Column -->
            <ng-container matColumnDef="first_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="user.firstName">
                    {{ "models.user.first_name" | translate }}
                </th>
                <td mat-cell *matCellDef="let user">{{ user.firstName }}</td>
            </ng-container>

            <!-- Last Name Column -->
            <ng-container matColumnDef="last_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="user.lastName">
                    {{ "models.user.last_name" | translate }}
                </th>
                <td mat-cell *matCellDef="let user">{{ user.lastName }}</td>
            </ng-container>

            <!-- Email Column -->
            <ng-container matColumnDef="email">
                <th mat-header-cell *matHeaderCellDef mat-sort-header="user.email">
                    {{ "models.user.email" | translate }}
                </th>
                <td mat-cell *matCellDef="let user">{{ user.email }}</td>
            </ng-container>

            <!-- Sites Column -->
            <ng-container matColumnDef="sites">
                <th mat-header-cell *matHeaderCellDef>
                    {{ "models.user.site" | translate }}
                </th>
                <td mat-cell *matCellDef="let user">{{ getUserSiteLabels(user.userSites) }}</td>
            </ng-container>

            <!-- unities Column -->
            <ng-container matColumnDef="unities">
                <th mat-header-cell *matHeaderCellDef>
                    {{ "models.user.unities" | translate }}
                </th>
                <td mat-cell *matCellDef="let user">{{ getLabels(user.unities) }}</td>
            </ng-container>

            <!-- Role Column -->
            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef>
                    {{ "models.user.role" | translate }}
                </th>
                <td mat-cell *matCellDef="let user">
                    <button mat-raised-button class="role-button" [ngClass]="getButtonClass(user.role)">
                        {{ getRoleLabel(user.role) | translate | titlecase }}
                    </button>
                </td>
            </ng-container>

            <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>
                </th>
                <td mat-cell *matCellDef="let user" class="action-buttons">
                    <button
                            mat-icon-button
                            aria-label="Edit User"
                            (click)="openUserDialog(user)"
                    >
                        <mat-icon color="primary" svgIcon="total-edit-gray"></mat-icon>
                    </button>
                    <button
                            mat-icon-button
                            aria-label="Delete User"
                            (click)="deleteUser(user)"
                    >
                        <mat-icon color="primary" svgIcon="total-bin"></mat-icon>
                    </button>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

            <tr class="mat-row" *matNoDataRow>
                <td class="mat-cell no-data-cell" colspan="8">
                    <div class="no-data-message">
                        {{ "pages.users_management.no_data" | translate }}
                    </div>
                </td>
            </tr>
        </table>

        <pagination
                [length]="totalItems"
                [pageOffset]="pageSize"
                [pageIndex]="pageIndex"
                [titleKey]="'pages.users_management.inspections_per_page'"
                (paginateChange)="onPaginate($event)">
        </pagination>
    </div>
</div>
